import type { TagContext, Tagger, Tags } from "../../lib/tagging-type";

export const podcastTags: Tagger = (state: Tags, context: TagContext) => {
  state.surrogateKeys.add(`podcasts/${context.site.index.slug}`);
  return state;
};
